import { privateHttp } from '../../config/axios';
import { API_ENDPOINTS } from '../../config/endpoints';
import {
    BuyCoinRequest,
    BuyCoinResponse,
    CoinHistoryRequest,
    CoinHistoryResponse,
    AutoPaymentRequest,
    AutoPaymentResponse,
    CoinProductListResponse,
    CoinPreOrderRequest,
    CoinPreOrderResponse
} from '../../types/payment/index';

// 코인 구매
export const buyCoin = async (request: BuyCoinRequest): Promise<BuyCoinResponse> => {
    const { data } = await privateHttp.post<BuyCoinResponse>(
        API_ENDPOINTS.PAYMENT.BUY_COIN,
        request
    );
    return data;
};

// 코인 사용 내역 조회
export const getCoinHistory = async (request: CoinHistoryRequest): Promise<CoinHistoryResponse> => {
    const { data } = await privateHttp.get<CoinHistoryResponse>(
        API_ENDPOINTS.PAYMENT.COIN_HISTORY,
        { params: request }
    );
    return data;
};

// 자동 결제 설정
export const setAutoPayment = async (request: AutoPaymentRequest): Promise<AutoPaymentResponse> => {
    const { data } = await privateHttp.post<AutoPaymentResponse>(
        API_ENDPOINTS.PAYMENT.AUTO_PAYMENT,
        request
    );
    return data;
};

// 자동 결제 설정 조회
export const getAutoPayment = async (): Promise<AutoPaymentResponse> => {
    const { data } = await privateHttp.get<AutoPaymentResponse>(
        API_ENDPOINTS.PAYMENT.AUTO_PAYMENT
    );
    return data;
};

// 코인 제품 리스트 조회
export const getCoinProductList = async (): Promise<CoinProductListResponse> => {
    const { data } = await privateHttp.get<CoinProductListResponse>(
        API_ENDPOINTS.USER_MYPAGE.COIN_PRODUCT_LIST
    );
    return data;
};

// 코인 사전 주문
export const createCoinPreOrder = async (request: CoinPreOrderRequest): Promise<CoinPreOrderResponse> => {
    const { data } = await privateHttp.post<CoinPreOrderResponse>(
        API_ENDPOINTS.USER_MYPAGE.COIN_PRE_ORDER,
        request
    );
    return data;
}; 